import styled from 'styled-components';

const TimelineStyles = styled.div`
  /* Timeline Styling */
  .timeline {
    position: relative;
    margin-top: 20px;
  }

  .timeline::after {
    content: '';
    position: absolute;
    width: 3px;
    background: linear-gradient(
      to bottom,
      transparent 0,
      var(--gray-2) 22px,
      var(--gray-2) calc(100% - 80px),
      transparent 100%
    );
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -1px;
  }

  .timeline-item {
    padding: 0px 40px 20px 40px;
    position: relative;
    width: 50%;
  }

  .timeline-item::after {
    content: attr(data-year);
    position: absolute;
    width: 14px;
    height: 14px;
    right: -8px;
    background-color: var(--highlight-blue);
    border: 2px solid var(--dark-bg);
    top: 22px;
    border-radius: 50%;
    z-index: 1;
  }

  .left {
    left: 0;
  }

  .right {
    left: 50%;
  }

  .left::before {
    content: " ";
    height: 0;
    position: absolute;
    top: 22px;
    width: 0;
    z-index: 1;
    right: 30px;
    border: medium solid var(--gray-2);
    border-width: 10px 0 10px 10px;
    border-color: transparent transparent transparent var(--gray-1);
  }

  .right::before {
    content: " ";
    height: 0;
    position: absolute;
    top: 22px;
    width: 0;
    z-index: 1;
    left: 30px;
    border: medium solid var(--gray-2);
    border-width: 10px 10px 10px 0;
    border-color: transparent var(--gray-1) transparent transparent;
  }

  .right::after {
    left: -10px;
  }

  .timeline-card {
    background-color: var(--dark-bg);
    padding: 0;
    border: 1px solid var(--gray-2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    position: relative;
    overflow: hidden;
  }

  .card-header h4 {
    font-size: 1.5rem;
    margin-bottom: 2px;
    color: var(--gray-1);
  }

  .card-header h5 {
    font-size: 1.3rem;
    margin-bottom: 3px;
    color: var(--highlight-blue);
    font-weight: normal;
  }

  .card-header h6 {
    font-size: 1.1rem;
    color: var(--gray-1);
    opacity: 0.7;
    margin: 0;
  }

  .card-body {
    margin-top: 10px;
    font-size: 1.3rem;
    line-height: 1.7;
  }

  .card-body ul li {
    padding: 2px 0;
    color: var(--gray-1);
    opacity: 0.9;
  }

  .sub-project {
    margin-bottom: 1.6rem;
    padding-bottom: 1.4rem;
    border-bottom: 1px solid var(--gray-2);
    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  .sub-project__name {
    font-size: 1.3rem;
    color: var(--highlight-blue);
    margin-bottom: 6px;
  }

  .sub-project__tech {
    font-size: 1.1rem;
    color: var(--gray-1);
    opacity: 0.65;
    margin-top: 6px;
    font-style: italic;
  }

  .single-project__name {
    font-size: 1.2rem;
    color: var(--highlight-blue);
    opacity: 0.85;
    margin-bottom: 8px;
  }

  .card-footer {
    background-color: transparent;
    border-top: 1px solid var(--gray-2);
    padding-top: 10px;
    margin-top: 10px;
  }

  .card-footer h6 {
    font-size: 1.2rem;
    margin-bottom: 4px;
    color: var(--highlight-blue);
  }

  .card-footer p {
    font-size: 1.2rem;
    color: var(--gray-1);
    opacity: 0.8;
    line-height: 1.6;
  }

  .card {
    background-color: var(--deep-dark);
    border: none;
  }

  i {
    padding: 5px;
  }

  .btn {
    margin: 5px;
  }

  a {
    color: var(--gray-1);
  }

  .main {
    margin: auto;
    padding-top: 100px;
  }

  .center {
    margin: auto;
    width: 100%;
    text-align: center;
  }

  .padding {
    margin: auto;
    width: 80%;
  }

  .timeline-card .accordion-header {
    background-color: var(--deep-dark);
    color: var(--gray-1);
    padding: 14px 16px;
    border-bottom: 1px solid var(--gray-2);
    cursor: pointer;
    &.open {
      background-color: var(--gray-2);
    }
  }

  .accordion-body {
    padding: 16px;
  }

  .accordion-fab {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    svg {
      width: 14px;
      height: 14px;
      color: var(--highlight-blue);
      opacity: 0.8;
    }
  }

  /* Print Styles */
  @media print {
    .timeline::after {
      display: none !important;
    }

    .timeline-item {
      width: 100% !important;
      left: 0 !important;
      padding: 0 0 15px 0 !important;
    }

    .timeline-item::before,
    .timeline-item::after {
      display: none !important;
    }

    .card-header {
      text-align: center !important;
    }

    /* Force all accordion bodies open regardless of isOpen state */
    .accordion-body {
      display: block !important;
    }

    /* Hide the expand/collapse icon — not useful in a PDF */
    .accordion-fab {
      display: none !important;
    }

    /* Start Work Experience on a fresh page */
    #technical-skills-section {
      page-break-before: always;
    }

    /* Tighter li spacing in accordion bodies */
    .card-body ul {
      margin: 0 !important;
      padding-left: 16px !important;
    }
    .card-body ul li {
      padding: 0 !important;
      margin: 0 !important;
      line-height: 1.4 !important;
    }

    /* Reduce p text by 2px for tighter print layout */
    .card-footer p {
      font-size: 1.0rem !important;
    }
    .sub-project__tech {
      font-size: 0.9rem !important;
    }
    .card-body {
      font-size: 1.1rem !important;
    }
  }

  /* Responsive Styles — left-rail timeline on mobile */
  @media (max-width: 768px) {
    /* Shift the vertical line to the left rail, fade at both ends */
    .timeline::after {
      display: block;
      left: 18px;
      margin-left: 0;
      background: linear-gradient(
        to bottom,
        transparent 0,
        var(--gray-2) 18px,
        var(--gray-2) calc(100% - 80px),
        transparent 100%
      );
    }

    /* All items full-width, indented to clear the rail */
    .timeline-item {
      width: 100%;
      padding-left: 52px;
      padding-right: 12px;
      left: 0 !important;
    }

    /* Dot on the left rail */
    .timeline-item::after {
      display: block;
      left: 11px;
      right: auto;
      top: 18px;
    }

    /* Hide the arrow pointers — not needed on single-column */
    .timeline-item::before {
      display: none;
    }

    .left, .right {
      left: 0;
      text-align: left;
    }

    .card-header h5 {
      font-size: 1.4rem;
    }

    .card-header h6 {
      font-size: 1.2rem;
    }

    .card-body, .card-footer {
      font-size: 1.3rem;
    }
  }
`;

export default TimelineStyles;
